import { useCallback, useMemo, useState } from 'react'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { Group } from '../../backoffice/dtos/groups/group';
import IdItemSelection from '../views/common/IdItemSelection';

export default function GroupEditModal(
    {
        isOpen,
        groups,
        addGroup,
        close
    }: {
        isOpen: boolean;
        groups: Group[]
        addGroup: (group: Group) => void;
        close: () => void;
    }
) {
    const { t } = useTranslation(['common'])
    const [group, setGroup] = useState<Group | undefined>(undefined);

    const selectedGroup = useCallback((selectedGroup: number | null) => {
        const selectedRole = groups.find(m => m.id === selectedGroup)

        if (selectedRole === undefined) {
            setGroup(undefined)
        } else {
            setGroup(selectedRole)
        }
    }, [groups]);

    const handleSubmit = useCallback(() => {
        if (group === undefined) {
            toast("Group not selected.");
            return;
        }

        addGroup(group);
        close();
    }, [group]);

    const roleOptions = useMemo(() => {
        return groups.map((it) => ({ value: it.id, label: it.description }))
    }, [groups])

    return (
        <>
            <Modal size='md' isOpen={isOpen} toggle={close}>
                <ModalHeader toggle={close}>{t('Department', { ns: 'common' })}</ModalHeader>
                <ModalBody>
                    <IdItemSelection id={group?.id ?? 0} setSelection={selectedGroup} options={roleOptions}/>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" onClick={handleSubmit}>
                        {t('Add', { ns: 'common' })}
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    )
}
